import 'slick-carousel';

class HeaderSlider {
  constructor() {
    this.settings = {
      slider: '.js-slick-header',
    };
  }

  init() {
    const $element = $(this.settings.slider);
    if ($element.length) {
      $('header').addClass('header--slider');
    }
    import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
      $element.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        speed: 300,
        adaptiveHeight: true,
        dots: false,
      });
      $element.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        const $text = $(slick.$slides[currentSlide]).find('.slide__main-text').html();
        $(slick.$slides[nextSlide]).find('.slide__main-text').html($text);
      });
    });
  }
}

export default HeaderSlider;
